/**
 * 
 * @author Jesus R. Nava Cruz
 * @date May 24, 2023
 * @version 1.0
 * 
 */

import ServiceConstant from "@/app/core/ServiceConstant";
import MainService from "@/app/services/MainService";

export default class SyncService extends MainService {

    static listAllPagination(params) {
        return this.postSEC(ServiceConstant.SYNC_LIST_ALL_PAGINATION, params)
    }

    static add(params) {
        return this.postSEC(ServiceConstant.SYNC_ADD, params);
    }

    static get(params){
        return this.postSEC(ServiceConstant.SYNC_GET, params);
    }

    static update(params) {
        return this.postSEC(ServiceConstant.SYNC_UPDATE, params);
    }

    static delete(params) {
        return this.postSEC(ServiceConstant.SYNC_DELETE, params);
    }

}
